import type { BiometricProvider } from '@/features/auth/services/biometric-credentials';

/**
 * Volatile (RAM-only, never persisted) holder for the credential captured at
 * authentication time. The biometric opt-in lives further downstream at onboarding
 * step 4, by which point the password has left the login form — so we stash it here
 * on a successful sign-in and read it back when the user flips the Face ID toggle.
 *
 * If the app is killed and onboarding is resumed, this is gone; the caller then falls
 * back to storing just the provider (empty password) per product decision.
 */
type PendingCredential = {
  email: string;
  /** Present only for email/password sign-in; omitted for social. */
  password?: string;
  provider: BiometricProvider;
};

let pending: PendingCredential | null = null;

export const setPendingCredential = (credential: PendingCredential): void => {
  pending = credential;
};

export const getPendingCredential = (): PendingCredential | null => pending;

export const clearPendingCredential = (): void => {
  pending = null;
};
